import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("sg_token", data.token);
      toast.success("Signed in.");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center px-4"
    >
      <form
        onSubmit={submit}
        className="w-full max-w-sm border border-neutral-800 p-8"
      >
        <p className="font-mono-label text-[11px] text-neutral-500">
          Admin Access
        </p>
        <h1 className="font-display font-black text-3xl mt-2 tracking-tighter">
          Sign in
        </h1>
        <div className="mt-8 space-y-4">
          <div>
            <label className="font-mono-label text-[10px] text-neutral-500">
              Email
            </label>
            <input
              required
              type="email"
              data-testid="admin-login-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mt-2 bg-transparent border-b border-neutral-700 focus:border-[#F5F5F0] py-2 outline-none text-[#F5F5F0]"
            />
          </div>
          <div>
            <label className="font-mono-label text-[10px] text-neutral-500">
              Password
            </label>
            <input
              required
              type="password"
              data-testid="admin-login-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full mt-2 bg-transparent border-b border-neutral-700 focus:border-[#F5F5F0] py-2 outline-none text-[#F5F5F0]"
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit-btn"
          className="mt-8 w-full bg-[#F5F5F0] text-black py-3 font-semibold hover:bg-[#EAEAE5] disabled:opacity-50"
        >
          {loading ? "Signing in…" : "Sign In"}
        </button>
        <a
          href="/"
          className="mt-6 block text-center text-xs font-mono-label text-neutral-500 hover:text-neutral-300"
        >
          ← Back to site
        </a>
      </form>
    </div>
  );
}
